module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.44fb6a03.svg";